import Vue from 'vue';

import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';

Sentry.init({
    enabled: process.env.NODE_ENV === 'production',
    dsn: 'https://430889915b714bb6a7dafcbcb245afed@sentry.io/1762606',
    environment: process.env.NODE_ENV,
    integrations: [
        /**
         * Passing in `Vue` is optional, if you do not pass it window.Vue must be present.
         *
         * Passing in `attachProps` is optional and is true if it is not provided.
         * If you set it to false, Sentry will suppress sending all Vue components’ props for logging.
         *
         * Passing in `logErrors` is optional and is false if it is not provided.
         * If you set it to true, Sentry will call original Vue’s logError function as well.
         * Please note that if you enable this integration, Vue will not call its logError internally.
         * This means that errors occurring in the Vue renderer will not show up in the developer console.
         * If you want to preserve this functionality, make sure to pass the logErrors: true option.
         */
        new Integrations.Vue({
            Vue,
            attachProps: true,
            logErrors: true,
        }),
    ],
});
